import { api } from "./common";
import { Id, Role } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id } & Pick<Role, "id">;

export const deleteRole = async (props: Props) => {
  await api(`v2/roles/${props.id}`, {
    method: "DELETE",
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { roles } = await fetchOrgEntities(props.subscriptionId);

  return { roles };
};
